module.exports = __webpack_public_path__ + "static/media/pdf-icon.a6de5922.svg";